<template>
  <div class="televalua between">
    <div class="user_evalua">
      <div class="row_title">用户评价</div>
      <div class="content">
        <div class="rat_item between" v-for="item in 4" :key="item">
          <div class="userinfo flex_start">
            <div class="usercover">
              <img src="../../../assets/telzx/aaaa1_sample.png" alt="" />
            </div>
            <div class="dec">
              <div class="ui1 ellipsis">用户188******81</div>
              <div class="ui2 ellipsis">
                专业，是个值得信赖的律师专业，是个值得信赖的律师专业，是个值得信赖的律师专业，是个值得信赖的律师
              </div>
              <div class="ui3 ellipsis">3小时前</div>
            </div>
          </div>
          <div>
            <el-rate v-model="value" disabled> </el-rate>
          </div>
        </div>
      </div>
    </div>
    <div class="tel_con_ski">
      <sub-title text="电话咨询技巧" />
      <div class="jq_list">
        <div class="jq_item flex">
          <div class="sort">1</div>
          <div class="nr">请先想好问题的具体内容</div>
        </div>

        <div class="jq_item flex">
          <div class="sort">2</div>
          <div class="nr">根据您的问题寻找合适的律师</div>
        </div>

        <div class="jq_item flex">
          <div class="sort">3</div>
          <div class="nr">建议拨打时间 9:00~21:00</div>
        </div>
      </div>
      <div class="lkzx">
        <div class="btn">立即咨询</div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "../../home/components/subTitle";
export default {
  components: { subTitle },
  data: () => ({
    value: 4,
  }),
  mounted(){
      console.log(this);
  }
};
</script>

<style lang="scss" scope>
.televalua {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  align-items: flex-start;
  .user_evalua {
    width: 816px;
    .row_title {
      font-size: 24px;
      line-height: 22px;
      color: #333333;
    }
    .content {
      margin-top: 30px;
      width: 100%;
      height: 614px;
      //   background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(38, 38, 38, 0.08);
      padding: 8px 25px 0;
      .rat_item {
        align-items: flex-start;
        padding: 32px 0;
        border-bottom: 1px solid #eeeeee;
        &:last-child {
          border-bottom: none;
        }
        .userinfo {
          align-items: flex-start;
          .usercover {
            margin-right: 16px;
            img {
              width: 66px;
              height: 66px;
              border-radius: 50%;
            }
          }
          .dec {
            width: 522px;
            .ui1 {
              font-size: 16px;
              color: #666666;
              line-height: 16px;
            }
            .ui2 {
              margin-top: 22px;
              font-size: 18px;
              color: #333333;
              line-height: 18px;
            }
            .ui3 {
              margin-top: 17px;
              font-size: 14px;
              color: #999999;
              line-height: 14px;
            }
          }
        }
      }
    }
  }
  .tel_con_ski {
    width: 354px;
    height: 500px;
    .jq_list {
      margin-top: 30px;
      .jq_item {
        width: 100%;
        height: 57px;
        margin-top: 12px;
        line-height: 57px;
        color: #fff;
        background: url("../../../assets/telzx/zxjq_bg.png");
        .sort {
          width: 52px;
          height: 57px;
          text-align: center;
          font-size: 24px;
          color: #0465ea;
          background-color: #edf5ff;
        }
        .nr {
          padding-left: 30px;
        }
      }
    }
    .lkzx {
      margin-top: 30px;
      width: 100%;
      height: 388px;
      background: url("../../../assets/telzx/likezx_bg.png") no-repeat;
      padding-top: 240px;
      .btn {
          cursor: pointer;
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        margin: 0 auto;
        background: #ff7e00;
        border-radius: 5px;
        font-size: 18px;
        color: #ffffff;
      }
    }
  }
}
</style>